<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
        ref="table" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="UsingTypeStr" label="应用类型" width="140"></el-table-column>
        <el-table-column label="故障类型" width="120">
          <template slot-scope="scope">
            {{ scope.row.UsingType === 'repair' ? (scope.row.LeaveTypeName || '通用') : (scope.row.LeaveTypeName || '-') }}
          </template>
        </el-table-column>
        <el-table-column label="审批规则" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.UsingType === 'repair_cost'">
              节点金额逐级
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门"></el-table-column>
        <el-table-column prop="Sort" label="序号" width="70"></el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div class="table-op-stacked">
              <el-button @click="showAddApprovalNode(scope.row)" type="text" style="margin: 0 !important;">
                审批人员设置
              </el-button>
              <el-button @click="showCopyToUsers(scope.row)" type="text" style="margin: 0 !important;">
                抄送人员设置
              </el-button>
              <el-button v-if="scope.row.UsingType === 'repair'" @click="showCompletionCc(scope.row)"
                type="text" style="margin: 0 !important;">
                完工抄送设置
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--分页-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="10" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑界面-->
      <el-dialog title="编辑报修审批流程" :visible.sync="editFormVisible" v-model="editFormVisible"
        width="520px" custom-class="dialog-compact"
        :close-on-click-modal="false" destroy-on-close>
        <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="应用类型" prop="UsingType">
            <el-select v-model="editForm.UsingType" placeholder="请选择应用类型" :disabled="true">
              <el-option v-for="item in usingTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <!-- 报修初审：故障类型（LeaveTypeId=0 表示通用） -->
          <el-form-item label="故障类型" prop="LeaveTypeId" v-if="editForm.UsingType === 'repair'">
            <el-select v-model="editForm.LeaveTypeId" placeholder="请选择故障类型">
              <el-option label="通用" :value="0"></el-option>
              <el-option v-for="item in faultTypeList" :key="item.Id" :label="item.Name"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-alert
            v-if="editForm.UsingType === 'repair_cost'"
            class="repair-form-alert"
            type="info"
            :closable="false"
            show-icon
            title="费用审批按节点金额阈值逐级审批"
            description="请到「审批人员设置」配置各级金额阈值，无需再配置流程金额区间。">
          </el-alert>

          <el-form-item label="序号" prop="Sort">
            <div class="form-inline-hint">
              <el-input-number v-model="editForm.Sort" :min="1" style="width: 120px;"></el-input-number>
              <span class="form-hint-text">同类型多条流程时取序号最小的执行</span>
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增报修审批流程" :visible.sync="addFormVisible" v-model="addFormVisible"
        width="520px" custom-class="dialog-compact"
        :close-on-click-modal="false" destroy-on-close>
        <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">

          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="应用类型" prop="UsingType">
            <el-select v-model="addForm.UsingType" placeholder="请选择应用类型">
              <el-option v-for="item in usingTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <!-- 报修初审：故障类型（LeaveTypeId=0 表示通用） -->
          <el-form-item label="故障类型" prop="LeaveTypeId" v-if="addForm.UsingType === 'repair'">
            <el-select v-model="addForm.LeaveTypeId" placeholder="请选择故障类型">
              <el-option label="通用" :value="0"></el-option>
              <el-option v-for="item in faultTypeList" :key="item.Id" :label="item.Name"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-alert
            v-if="addForm.UsingType === 'repair_cost'"
            class="repair-form-alert"
            type="info"
            :closable="false"
            show-icon
            title="费用审批按节点金额阈值逐级审批"
            description="请到「审批人员设置」配置各级金额阈值，无需再配置流程金额区间。">
          </el-alert>

          <el-form-item label="序号" prop="Sort">
            <div class="form-inline-hint">
              <el-input-number v-model="addForm.Sort" :min="1" style="width: 120px;"></el-input-number>
              <span class="form-hint-text">同类型多条流程时取序号最小的执行</span>
            </div>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--审批节点配置：网格对齐参考请假审批。最后修改：2026-10-29 -->
      <el-dialog title="审批人员设置"
        :width="currentUsingType === 'repair_cost' ? '860px' : '720px'"
        :visible.sync="addApprovalNodeVisible"
        :close-on-click-modal="false" center destroy-on-close>
        <el-alert
          v-if="currentUsingType === 'repair_cost'"
          class="repair-node-alert"
          type="info"
          :closable="false"
          show-icon
          title="报价金额 ≥ 本级阈值时进入该节点"
          description="首节点阈值须为 0，后续节点阈值须递增；未达阈值的更高节点不会生成。">
        </el-alert>
        <el-table :data="approvalNodes" class="node-table" style="width: 100%;"
          empty-text="暂无审批节点，点击下方「添加节点」">
          <el-table-column prop="index" label="序号" width="64" align="center">
            <template slot-scope="scope">
              <span class="node-index">{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="node-grid node-grid-head" :class="{ 'is-cost': currentUsingType === 'repair_cost' }">
                <span>审批角色</span>
                <span>审批人</span>
                <span v-if="currentUsingType === 'repair_cost'">
                  金额阈值
                  <el-tooltip content="报价金额达到该阈值才流转到本节点" placement="top">
                    <i class="el-icon-question node-head-help"></i>
                  </el-tooltip>
                </span>
                <span class="node-head-op">操作</span>
              </div>
            </template>
            <template slot-scope="scope">
              <el-form :model="scope.row" :rules="approvalFormRules"
                :ref="`approvalForm${scope.$index}`"
                class="node-grid" :class="{ 'is-cost': currentUsingType === 'repair_cost' }">
                <el-form-item prop="role">
                  <el-select v-model="scope.row.role" placeholder="请选择角色"
                    @change="roleChange(scope.$index)">
                    <el-option v-for="item in repairRoleOptions" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="specificUsers">
                  <el-select v-model="scope.row.specificUsers" multiple filterable
                    placeholder="请选择审批人员"
                    @change="specificUsersChange(scope.$index)">
                    <el-option v-for="user in userList" :key="String(user.Id)" :label="user.TeacherName"
                      :value="String(user.Id)"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="currentUsingType === 'repair_cost'" prop="amountThreshold">
                  <div class="node-threshold">
                    <el-input-number v-model="scope.row.amountThreshold" :min="0" :step="100"
                      :precision="2" controls-position="right" />
                    <span class="node-unit">元</span>
                  </div>
                </el-form-item>
                <el-form-item class="node-op">
                  <el-button type="text" icon="el-icon-delete" class="node-del-btn"
                    @click="removeNode(scope.$index)">删除</el-button>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addNode" style="margin-right: 10px;">添加节点</el-button>
          <el-button type="primary" @click="submitApprovalNodes" style="margin-right: 10px;">保存</el-button>
          <el-button @click.native="addApprovalNodeVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <!--抄送人员设置-->
      <el-dialog :title="copyDialogTitle" width="50%" :visible.sync="copyToUsersVisible"
        :close-on-click-modal="false" center destroy-on-close>
        <!-- label-width 避免未设宽度时浮动 label 与多选 tag 重叠。最后修改：2026-09-20 -->
        <el-form :model="copyToForm" ref="copyToForm" label-width="90px">
          <el-form-item label="抄送人员" prop="copyToUsers" style="margin-bottom: 20px;">
            <el-select v-model="copyToForm.copyToUsers" multiple filterable
              placeholder="请选择或输入人员" style="width: 100%;">
              <el-option v-for="user in userList" :key="String(user.Id)" :label="user.TeacherName"
                :value="String(user.Id)"></el-option>
            </el-select>
            <div style="margin-top: 10px; color: #606266; font-size: 12px;">
              {{ copyDialogHint }}
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="copyToUsersVisible = false">取消</el-button>
          <el-button type="primary" @click.native="saveCopyToUsers" :loading="copyToLoading">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="完工抄送设置" width="50%" :visible.sync="completionCcVisible"
        :close-on-click-modal="false" center destroy-on-close>
        <el-form label-width="90px">
          <el-form-item label="故障类型">
            <el-input :value="completionFaultTypeName" disabled></el-input>
          </el-form-item>
          <el-form-item label="抄送人员">
            <el-select v-model="completionCcUsers" multiple filterable placeholder="请选择人员" style="width: 100%;">
              <el-option v-for="user in userList" :key="String(user.Id)" :label="user.TeacherName"
                :value="String(user.Id)"></el-option>
            </el-select>
          </el-form-item>
          <div style="color: #909399; font-size: 12px;">报修完工后通知以上人员，发起人始终会收到通知。</div>
        </el-form>
        <div slot="footer">
          <el-button @click="completionCcVisible = false">取消</el-button>
          <el-button type="primary" :loading="completionCcLoading" @click="saveCompletionCc">保存</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { testapi } from '../../api/modules/auth';
import { getLeaveApprovalProcessListPage, removeLeaveApprovalProcess, editLeaveApprovalProcess, addLeaveApprovalProcess, getProcessOfficer, addProcessOfficer, getProcessCc, saveProcessCc, getRepairCompletionCc, saveRepairCompletionCc, deleteRepairProcessesBySchool } from '../../api/modules/misc';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getRepairFaultTypeList } from '../../api/modules/repair';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {},
      searchList: [{ label: '名称', key: 'name' }],
      // 仅包含报修相关类型
      usingTypeOptions: [
        { value: 'repair', label: '报修初审' },
        { value: 'repair_cost', label: '报修费用审批' }
      ],
      // 报修场景只支持指定人员
      repairRoleOptions: [
        { label: '指定人员', value: 'specificPerson' }
      ],
      users: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [],
      DepartmentId: 0,
      faultTypeList: [],

      // 编辑
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        UsingType: [{ required: true, message: '请选择应用类型', trigger: 'change' }]
      },
      editForm: {
        Id: 0,
        Name: '',
        UsingType: 'repair',
        LeaveTypeId: 0,
        Sort: 1,
        DepartmentId: 0,
        MinAmount: undefined,
        MaxAmount: undefined
      },

      // 新增
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        UsingType: [{ required: true, message: '请选择应用类型', trigger: 'change' }]
      },
      addForm: {
        Name: '',
        UsingType: 'repair',
        LeaveTypeId: 0,
        Sort: 1,
        DepartmentId: 0,
        MinAmount: undefined,
        MaxAmount: undefined
      },

      // 审批节点
      processId: '',
      currentUsingType: 'repair',
      addApprovalNodeVisible: false,
      approvalNodes: [],
      approvalFormRules: {
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        specificUsers: [{ required: true, type: 'array', min: 1, message: '请选择审批人员', trigger: 'change' }]
      },
      userList: [],

      // 抄送
      copyToUsersVisible: false,
      copyToLoading: false,
      copyToForm: { copyToUsers: [] },
      currentProcessId: '',
      completionCcVisible: false,
      completionCcLoading: false,
      completionSchoolId: 0,
      completionFaultTypeId: 0,
      completionFaultTypeName: '',
      completionCcUsers: []
    };
  },
  computed: {
    copyDialogTitle() {
      return this.currentUsingType === 'repair_cost' ? '费用通过抄送人员设置' : '初审通过抄送人员设置';
    },
    copyDialogHint() {
      return this.currentUsingType === 'repair_cost'
        ? '费用审批全部通过后，系统将通知以上人员。'
        : '报修初审全部通过后，系统将通知以上人员。';
    }
  },

  methods: {
    /** 解析审批人 ID（兼容 | 与 / 分隔） */
    parseSpecificUserIds(raw) {
      if (!raw) return [];
      return String(raw).split(/[|/,，、]/).map(s => s.trim()).filter(Boolean);
    },

    /** 已保存的审批人不在下拉列表时补入选项，避免显示纯数字 ID */
    ensureUserOptions(ids, nodeName) {
      const existIds = new Set(this.userList.map(u => String(u.Id)));
      const names = (nodeName || '').replace(/审批$/, '').split(/[、,，/|]/).map(s => s.trim()).filter(Boolean);
      ids.forEach((id, idx) => {
        const sid = String(id);
        if (!existIds.has(sid)) {
          this.userList.push({
            Id: sid,
            TeacherName: names[idx] || names[0] || `教职工(${sid})`
          });
          existIds.add(sid);
        }
      });
    },

    async loadTeacherOptions(departmentId) {
      const res = await getTeacherMasterList({ departmentId });
      if (res.data && res.data.success) {
        this.userList = res.data.response || [];
      } else {
        this.userList = [];
      }
    },

    // ─── 列表 ──────────────────────────────────────────────────
    handleQuery() {
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        usingTypes: 'repair,repair_cost',
        ...this.filters
      };
      this.listLoading = true;
      testapi();
      getLeaveApprovalProcessListPage(para).then(res => {
        this.total = res.data.response.dataCount;
        const students = res.data.response.data;
        students.forEach(item => {
          item.UsingTypeStr = item.UsingType === 'repair' ? '报修初审' : '报修费用审批';
        });
        this.users = students;
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.handleQuery();
      // 加载该部门下的故障类型，供新增/编辑时选择
      this.loadFaultTypes(data.value);
    },

    loadFaultTypes(departmentId) {
      getRepairFaultTypeList({ departmentId }).then(res => {
        if (res.data && res.data.success) {
          this.faultTypeList = res.data.response || [];
        }
      });
    },

    formatAmountRange(min, max) {
      if (min == null && max == null) return '兜底（无限制）';
      if (min == null) return `< ${max} 元`;
      if (max == null) return `≥ ${min} 元`;
      return `${min} ~ ${max} 元`;
    },

    // ─── 工具栏 ────────────────────────────────────────────────
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search;
      } else {
        this.filters = { key: item.search };
      }
      this[item.Func].apply(this, item);
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectCurrentRow(row);
    },

    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(val, true);
        });
      }
    },

    // ─── 新增 ──────────────────────────────────────────────────
    handleAdd() {
      this.addForm = {
        Name: '',
        UsingType: 'repair',
        LeaveTypeId: 0,
        Sort: 1,
        DepartmentId: this.DepartmentId || 0,
        MinAmount: undefined,
        MaxAmount: undefined
      };
      this.addFormVisible = true;
    },

    addSubmit() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return;
        this.addLoading = true;
        const para = { ...this.addForm };
        para.LeaveTypeId = Number(para.LeaveTypeId) > 0 ? Number(para.LeaveTypeId) : 0;
        addLeaveApprovalProcess(para).then(res => {
          this.addLoading = false;
          if (res.data.success) {
            this.$message({ message: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.handleQuery();
          } else {
            this.$message({ message: res.data.msg || '新增失败', type: 'error' });
          }
        }).catch(() => { this.addLoading = false; });
      });
    },

    // ─── 编辑 ──────────────────────────────────────────────────
    handleEdit() {
      if (!this.currentRow) {
        this.$message({ message: '请先选择要编辑的记录', type: 'warning' });
        return;
      }
      const row = this.currentRow;
      this.editForm = {
        Id: row.Id,
        Name: row.Name,
        UsingType: row.UsingType,
        LeaveTypeId: Number(row.LeaveTypeId) > 0 ? Number(row.LeaveTypeId) : 0,
        Sort: row.Sort || 1,
        DepartmentId: row.DepartmentId || 0,
        MinAmount: row.MinAmount,
        MaxAmount: row.MaxAmount
      };
      this.editFormVisible = true;
    },

    editSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.editLoading = true;
        const para = { ...this.editForm };
        para.LeaveTypeId = Number(para.LeaveTypeId) > 0 ? Number(para.LeaveTypeId) : 0;
        editLeaveApprovalProcess(para).then(res => {
          this.editLoading = false;
          if (res.data.success) {
            this.$message({ message: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.handleQuery();
          } else {
            this.$message({ message: res.data.msg || '修改失败', type: 'error' });
          }
        }).catch(() => { this.editLoading = false; });
      });
    },

    // ─── 删除 ──────────────────────────────────────────────────
    handleDel() {
      if (!this.currentRow) {
        this.$message({ message: '请先选择要删除的记录', type: 'warning' });
        return;
      }
      this.$confirm('确认删除该审批流程？', '提示', { type: 'warning' }).then(async () => {
        const res = await removeLeaveApprovalProcess({ id: this.currentRow.Id });
        if (res.data.success) {
          this.$message({ message: '删除成功', type: 'success' });
          this.currentRow = null;
          this.handleQuery();
        } else {
          this.$message({ message: res.data.msg || '删除失败', type: 'error' });
        }
      }).catch(() => {});
    },

    handleDeleteSchoolRepairConfig() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      this.$confirm(
        '将删除当前学校全部报修初审、费用审批流程、审批节点、通过抄送和完工抄送配置，且不可恢复，确认继续吗？',
        '危险操作确认',
        { type: 'warning', confirmButtonText: '确认删除', cancelButtonText: '取消' }
      ).then(() => deleteRepairProcessesBySchool(this.DepartmentId)).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg || '删除成功');
          this.currentRow = null;
          this.handleQuery();
        } else {
          this.$message.error(res.data.msg || '删除失败');
        }
      }).catch(() => {});
    },

    // ─── 审批节点 ─────────────────────────────────────────────
    async showAddApprovalNode(row) {
      this.processId = row.Id;
      this.currentUsingType = row.UsingType;
      this.approvalNodes = [];
      this.addApprovalNodeVisible = true;
      try {
        await this.loadTeacherOptions(row.DepartmentId);
        const res = await getProcessOfficer({ processId: row.Id });
        if (res.data && res.data.success) {
          const nodes = res.data.response || [];
          this.approvalNodes = nodes.map((n, i) => {
            const specificUsers = this.parseSpecificUserIds(n.SpecificPerson || n.specificPerson);
            this.ensureUserOptions(specificUsers, n.NodeName || n.nodeName);
            return {
              index: n.Index || n.index || (i + 1),
              nodeName: n.NodeName || n.nodeName || '',
              role: n.Role || n.role || 'specificPerson',
              specificUsers: specificUsers.map(id => String(id)),
              days: 0,
              hours: 0,
              amountThreshold: n.AmountThreshold == null ? 0 : Number(n.AmountThreshold)
            };
          });
          if (this.approvalNodes.length === 0) this.addNode();
        }
      } catch (e) {
        this.$message.error('加载审批人员失败');
      }
    },

    addNode() {
      const nextIndex = this.approvalNodes.length > 0
        ? Math.max(...this.approvalNodes.map(n => n.index)) + 1
        : 1;
      this.approvalNodes.push({
        index: nextIndex,
        nodeName: `审批节点${nextIndex}`,
        role: 'specificPerson',
        specificUsers: [],
        days: 0,
        hours: 0,
        amountThreshold: 0
      });
    },

    removeNode(index) {
      this.approvalNodes.splice(index, 1);
      // 重新编号
      this.approvalNodes.forEach((node, i) => { node.index = i + 1; });
    },

    roleChange(index) {
      this.approvalNodes[index].specificUsers = [];
    },

    specificUsersChange(index) {
      const node = this.approvalNodes[index];
      const idSet = new Set((node.specificUsers || []).map(id => String(id)));
      const selectedUsers = this.userList.filter(u => idSet.has(String(u.Id)));
      node.nodeName = selectedUsers.map(u => u.TeacherName).join('、') || node.nodeName;
    },

    submitApprovalNodes() {
      const invalid = this.approvalNodes.find(n =>
        n.role === 'specificPerson' && (!n.specificUsers || !n.specificUsers.length)
      );
      if (invalid) {
        this.$message.error('请为指定人员节点选择审批人');
        return;
      }
      const para = {
        processId: this.processId,
        processOfficerDetails: this.approvalNodes.map(node => ({
          index: node.index,
          nodeName: node.nodeName,
          role: node.role,
          specificUsers: (node.specificUsers || []).map(id => String(id)),
          days: 0,
          amountThreshold: this.currentUsingType === 'repair_cost' ? Number(node.amountThreshold || 0) : null
        }))
      };
      addProcessOfficer(para).then(res => {
        if (res.data.success) {
          this.$message({ message: '保存成功', type: 'success' });
          this.addApprovalNodeVisible = false;
        } else {
          this.$message({ message: res.data.msg || '保存失败', type: 'error' });
        }
      });
    },

    // ─── 抄送 ──────────────────────────────────────────────────
    async showCopyToUsers(row) {
      this.currentProcessId = row.Id;
      this.currentUsingType = row.UsingType;
      try {
        await this.loadTeacherOptions(row.DepartmentId);
        const res = await getProcessCc({ processId: row.Id });
        if (res.data && res.data.success && res.data.response) {
          const ids = (res.data.response.CcPersonIds || '').split(/[|/,，、]/).filter(s => s).map(s => String(s));
          this.ensureUserOptions(ids, res.data.response.CcPersonNames);
          this.copyToForm.copyToUsers = ids;
        } else {
          this.copyToForm.copyToUsers = [];
        }
      } catch (e) {
        this.$message.error('加载抄送人员失败');
      }
      this.copyToUsersVisible = true;
    },

    saveCopyToUsers() {
      this.copyToLoading = true;
      const para = {
        ProcessId: this.currentProcessId,
        CcPersonIds: this.copyToForm.copyToUsers.join('|'),
        CcPersonNames: this.copyToForm.copyToUsers
          .map(id => { const u = this.userList.find(u => String(u.Id) === String(id)); return u ? u.TeacherName : ''; })
          .filter(n => n).join('|')
      };
      saveProcessCc(para).then(res => {
        this.copyToLoading = false;
        if (res.data.success) {
          this.$message({ message: '保存成功', type: 'success' });
          this.copyToUsersVisible = false;
        } else {
          this.$message({ message: res.data.msg || '保存失败', type: 'error' });
        }
      }).catch(() => { this.copyToLoading = false; });
    },

    async showCompletionCc(row) {
      const schoolId = Number(row.DepartmentId) > 0 ? Number(row.DepartmentId) : Number(this.DepartmentId);
      if (!schoolId) {
        this.$message.warning('请先在左侧选择学校');
        return;
      }
      // LeaveTypeId=0 表示通用完工抄送。最后更新：2026-10-29
      const faultTypeId = Number(row.LeaveTypeId) > 0 ? Number(row.LeaveTypeId) : 0;
      this.completionSchoolId = schoolId;
      this.completionFaultTypeId = faultTypeId;
      this.completionFaultTypeName = faultTypeId > 0
        ? (row.LeaveTypeName || '当前故障类型')
        : (row.LeaveTypeName || '通用');
      this.completionCcUsers = [];
      await this.loadTeacherOptions(schoolId);
      const res = await getRepairCompletionCc({
        schoolId,
        faultTypeId
      });
      if (res.data && res.data.success && res.data.response) {
        const ids = String(res.data.response.CcPersonIds || '')
          .split(/[|/,，、]/).filter(Boolean).map(id => String(id));
        this.ensureUserOptions(ids, res.data.response.CcPersonNames);
        this.completionCcUsers = ids;
      }
      this.completionCcVisible = true;
    },

    saveCompletionCc() {
      const schoolId = Number(this.completionSchoolId);
      if (!schoolId) {
        this.$message.warning('学校不能为空，请先在左侧选择学校');
        return;
      }
      this.completionCcLoading = true;
      const names = this.completionCcUsers.map(id => {
        const user = this.userList.find(item => String(item.Id) === String(id));
        return user ? user.TeacherName : '';
      }).filter(Boolean);
      saveRepairCompletionCc({
        SchoolId: schoolId,
        FaultTypeId: Number(this.completionFaultTypeId) > 0 ? Number(this.completionFaultTypeId) : 0,
        CcPersonIds: this.completionCcUsers.join('|'),
        CcPersonNames: names.join('|')
      }).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功');
          this.completionCcVisible = false;
        } else {
          this.$message.error(res.data.msg || '保存失败');
        }
      }).finally(() => {
        this.completionCcLoading = false;
      });
    }
  },

  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
/* 与表单内容区对齐，且宽度扣掉左边距，避免撑出横向滚动条。最后修改：2026-10-29 */
.repair-form-alert {
  margin: 0 0 18px 120px;
  width: calc(100% - 120px);
  box-sizing: border-box;
}

.repair-node-alert {
  margin-bottom: 14px;
}

.form-inline-hint {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 0;
}

.form-hint-text {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  white-space: normal;
}

/* 审批节点网格：角色 / 审批人 / 金额阈值 / 操作。创建于 2026-10-29 */
.node-grid {
  display: grid;
  grid-template-columns: 140px minmax(200px, 1fr) 64px;
  column-gap: 16px;
  align-items: center;
  width: 100%;
  text-align: left;
}

.node-grid.is-cost {
  grid-template-columns: 140px minmax(180px, 1fr) 168px 64px;
}

.node-grid-head {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.node-head-help {
  margin-left: 2px;
  color: #94a3b8;
  cursor: help;
}

.node-head-op,
.node-op {
  text-align: center;
}

.node-grid >>> .el-form-item {
  margin: 0;
}

.node-grid >>> .el-select,
.node-grid >>> .el-input {
  width: 100%;
}

.node-grid >>> .el-form-item__error {
  padding-top: 2px;
}

.node-grid >>> .el-form-item__content {
  display: block;
  width: 100%;
  margin-left: 0 !important;
}

.node-table >>> .el-table__row td {
  padding: 14px 0;
}

.node-table >>> td.el-table__cell > .cell,
.node-table >>> th.el-table__cell > .cell {
  display: block !important;
  width: 100%;
  text-align: left;
}

.node-table >>> td.el-table__cell:first-child > .cell,
.node-table >>> th.el-table__cell:first-child > .cell {
  text-align: center;
}

.node-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 600;
}

.node-threshold {
  display: flex;
  align-items: center;
}

.node-threshold >>> .el-input-number {
  width: 120px;
}

.node-threshold >>> .el-input-number .el-input__inner {
  padding-left: 8px;
  padding-right: 40px;
  text-align: left;
}

.node-unit {
  margin-left: 6px;
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
}

.node-del-btn {
  color: #ef4444;
}

.node-del-btn:hover,
.node-del-btn:focus {
  color: #dc2626;
}
</style>
